module.exports = __webpack_public_path__ + "static/img/cattle-watch.42b8c43.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/cattle-watch.png
// module id = CHnN
// module chunks = 0